<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="活动名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'activityName',
              {
                rules: [
                  { required: true, message: '请输入活动名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入活动名称"
          />
        </a-form-item>
        <a-form-item
          label="活动简介"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="20"
            v-decorator="['activityDescribe']"
            placeholder="请输入活动简介"
          />
        </a-form-item>
        <a-form-item
          label="初始按钮文案"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="5"
            v-decorator="['buttonText']"
            placeholder="请输入初始按钮文案(默认：去完成)，限制5个字"
          />
        </a-form-item>
        <a-form-item
          label="icon图"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="['iconUrl']"
          />
        </a-form-item>
        <a-form-item
          label="活动类别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            @change="changeActivityType"
            placeholder="请选择活动类别"
            v-decorator="[
              'activityType',
              { rules: [{ required: true, message: '请选择活动类别' }] },
            ]"
            :triggerChange="true"
            dictCode="activity_type"
          />
        </a-form-item>

        <a-form-item
          v-if="showTemplateFlag"
          label="消息模板"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select v-decorator="['expandField1']" placeholder="请选择消息模板">
            <a-select-option
              v-for="(item, index) in XcxTemplateList"
              :value="item.messageId"
              :key="index"
              >{{ item.templateName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="showAppIdFlag"
          label="财富号appId"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="20"
            v-decorator="['expandField1']"
            placeholder="请输入财富号appId"
          />
        </a-form-item>

        <a-form-item
          v-if="showTaskFlag"
          label="任务唯一标识"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="10"
            v-decorator="[
              'taskOnlyFlag',
              { rules: [{ required: true, message: '请输入任务唯一标识' }] },
            ]"
            placeholder="请输入任务唯一标识"
          />
        </a-form-item>
        <a-form-item
          label="活动周期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-range-picker
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            v-decorator="['pageStartEndTime']"
            :show-time="{
              hideDisabledOptions: true,
              defaultValue: [
                moment('00:00:00', 'HH:mm:ss'),
                moment('11:59:59', 'HH:mm:ss'),
              ],
            }"
          />
        </a-form-item>

        <a-form-item
          label="跳转链接"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="500"
            v-decorator="['jumpUrl']"
            placeholder="请输入跳转链接"
          />
        </a-form-item>

        <a-form-item
          label="是否发奖"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="isAward"
            @change="changeHandler"
          />
        </a-form-item>
        <a-form-item
          v-if="isAward"
          label="奖品来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'prizeSource',
              { rules: [{ required: true, message: '请选择奖品来源' }] },
            ]"
            placeholder="请选择奖品来源"
            @change="prizeSourceHandle"
          >
            <a-select-option
              v-for="(item, index) in prizeSourceList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="isAward"
          label="奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'relevancePrize',
              { rules: [{ required: true, message: '请选择奖品' }] },
            ]"
            placeholder="请选择奖品"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="是否奖励抽奖机会"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="isDrawChance"
            @change="changeHandler2"
          />
        </a-form-item>
        <a-form-item
          v-if="isDrawChance"
          label="奖励抽奖机会次数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            v-decorator="[
              'chanceNum',
              {
                rules: [
                  { required: true, message: '请输入完成后奖励抽奖次数' },
                ],
              },
            ]"
            placeholder="请输入完成后奖励抽奖次数"
            type="number"
          ></a-input>
        </a-form-item>
        <!--<a-form-item  label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch checked-children="是" un-checked-children="否" v-model="status" @change="changeHandler1"/>
        </a-form-item>-->
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="sortIndex"
            v-decorator="[
              'sort',
              { rules: [{ required: true, message: '请输入排序' }] },
            ]"
            placeholder="排序数字越小越靠前"
            type="number"
          ></a-input>
        </a-form-item>
        <!--    step2        -->
        <a-form-item
          label="活动渠道"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-multi-select-tag
            mode="multiple"
            v-decorator="['activityChannel']"
            :triggerChange="true"
            placeholder="请选择活动渠道"
            dictCode="activity_channel_type"
          />
        </a-form-item>

        <!--    step3        -->
        <a-form-item
          label="目标人群"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-multi-select-tag
            mode="multiple"
            v-decorator="['crowd']"
            :triggerChange="true"
            placeholder="请选择目标人群"
            dictCode="activity_crowd"
          />
        </a-form-item>

        <a-form-item
          label="是否发送模板消息"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="isSendMessage"
            @change="messageChangeHandler"
          />
        </a-form-item>
        <a-form-item
          v-if="isSendMessage"
          label="请选择模板"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'templateId',
              { rules: [{ required: true, message: '请选择消息模板' }] },
            ]"
            placeholder="请选择消息模板"
          >
            <a-select-option
              v-for="(item, index) in AllTemplateList"
              :value="item.id"
              :key="index"
              >{{ item.templateName }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
// import JImageUpload from '@/components/jeecg/JImageUpload';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'AddMarketingActivityModal',
  components: {
    // JImageUpload,
    JDate,
    JMultiSelectTag,
    UploadImage,
  },
  data() {
    return {
      fileList: '',
      AllTemplateList: [], //模板列表
      XcxTemplateList: [], //模板列表
      isSendMessage: false, //是否发送模板消息开关，默认关闭状态
      isAward: false, //是否发奖开关，默认关闭状态
      isDrawChance: false, //是否增加抽奖机会开关，默认关闭
      //status:false,//体验周期不是永久时配置项显示
      showTaskFlag: false, //任务唯一标识，默认不显示
      showTemplateFlag: false, //消息模板，默认不展示
      showAppIdFlag: false, //appid，默认不显示
      value: 1,
      prizesList: [], //奖品列表
      prizeSourceList: [
        {
          name: '奖品库',
          value: '1',
        },
        {
          name: '积分库',
          value: '2',
        },
      ], //奖品来源

      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/run/activity/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/run/activity/edit',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
        getTemplateList:
          process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/all',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      if (record.isAward === '1') {
        this.isAward = true;
      } else {
        this.isAward = false;
      }
      /*if (record.status === '1'){
          this.status = true
        }else {
          this.status = false
        }*/
      if (record.isDrawChance === '1') {
        this.isDrawChance = true;
      } else {
        this.isDrawChance = false;
      }
      if (record.isSendMessage === '1') {
        this.isSendMessage = true;
      } else {
        this.isSendMessage = false;
      }
      this.prizeSourceHandle(record.prizeSource);
      this.templateHandler();
      if (record.activityType === '2') {
        this.showTaskFlag = true;
      } else {
        this.showTaskFlag = false;
      }
      if (record.activityType === '6') {
        this.showTemplateFlag = true;
      } else {
        this.showTemplateFlag = false;
      }
      if (record.activityType === '7') {
        this.showAppIdFlag = true;
      } else {
        this.showAppIdFlag = false;
      }
      this.fileList = record.iconUrl;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          iconUrl: record.iconUrl
            ? process.env.VUE_APP_FILE_PATH + record.iconUrl
            : '',
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'expandField1',
            'buttonText',
            // 'iconUrl',
            'isSendMessage',
            'templateId',
            'taskOnlyFlag',
            'activityDescribe',
            'isDrawChance',
            'chanceNum',
            'jumpUrl',
            'sort',
            'activityName',
            'activityType',
            'pageStartEndTime',
            'isAward',
            'prizeSource',
            'relevancePrize',
            'status',
            'activityChannel',
            'crowd'
          )
        );
      });

      if (this.model.pageStartEndTime) {
        var ary = this.model.pageStartEndTime.split('~');
        //formData.startEndTime[0].format('YYYY-MM-DD HH:mm:ss') + "~" + formData.startEndTime[1].format('YYYY-MM-DD HH:mm:ss')
        this.model.pageStartEndTime = [
          moment(ary[0], 'YYYY-MM-DD HH:mm:ss'),
          moment(ary[1], 'YYYY-MM-DD HH:mm:ss'),
        ];
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }

          let formData = Object.assign(this.model, values);
          if (
            formData.pageStartEndTime &&
            formData.pageStartEndTime.length !== 0
          ) {
            formData.pageStartEndTime =
              formData.pageStartEndTime[0].format('YYYY-MM-DD HH:mm:ss') +
              '~' +
              formData.pageStartEndTime[1].format('YYYY-MM-DD HH:mm:ss');
          } else {
            formData.pageStartEndTime = '';
          }
          formData.isAward = that.isAward === true ? '1' : '0';
          //formData.status = that.status === true ? '1' : '0';
          formData.isDrawChance = that.isDrawChance === true ? '1' : '0';
          formData.isSendMessage = that.isSendMessage === true ? '1' : '0';
          if (formData.showTaskFlag === false) {
            formData.taskOnlyFlag = '';
          }
          formData.iconUrl = this.fileList;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'buttonText',
          'expandField1',
          'iconUrl',
          'isSendMessage',
          'templateId',
          'taskOnlyFlag',
          'activityDescribe',
          'isDrawChance',
          'chanceNum',
          'jumpUrl',
          'sort',
          'activityName',
          'activityType',
          'pageStartEndTime',
          'isAward',
          'prizeSource',
          'relevancePrize',
          'status',
          'activityChannel',
          'crowd'
        )
      );
    },

    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },

    disabledDate(current) {
      return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
    },

    disabledRangeTime(_, type) {
      if (type === 'start') {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      };
    },

    changeHandler(e) {
      this.isAward = e;
    },
    /*changeHandler1(e){
        this.status = e
      },*/
    changeHandler2(e) {
      this.isDrawChance = e;
    },
    onChange(e) {
      console.log('radio checked', e.target.value);
    },

    /**获取奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (type === '2') {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
          console.log(this.prizesList);
        }
      });
    },

    prizeSourceHandle(e) {
      if (e === '1' || e === '2') {
        this.prizesList = [];
        this.getPrizesList(e);
        //this.showPrizeList = true;
      } else {
        this.prizesList = [];
        //this.showPrizeList = false;
      }
    },
    changeActivityType(e) {
      if (e === '2') {
        //每日任务
        this.showTaskFlag = true;
      } else {
        this.showTaskFlag = false;
      }
      if (e === '6') {
        //订阅小程序
        this.showTemplateFlag = true;
      } else {
        this.showTemplateFlag = false;
      }

      if (e === '7') {
        //关注生活号
        this.showAppIdFlag = true;
      } else {
        this.showAppIdFlag = false;
      }
    },
    messageChangeHandler(e) {
      this.isSendMessage = e;
    },
    templateHandler() {
      this.AllTemplateList = [];
      this.XcxTemplateList = [];
      getAction(this.url.getTemplateList).then((res) => {
        if (res.success) {
          let data = res.result;
          data.forEach((item) => {
            if (item.templateType === '2') {
              this.XcxTemplateList.push(item);
            }
          });
          console.log(this.XcxTemplateList);
          this.AllTemplateList = data;
        }
      });
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        iconUrl: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
<style scoped>
.steps-content {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  /*text-align: center;*/
  padding-top: 80px;
}

.steps-action {
  margin-top: 24px;
}
</style>
